<template>
	<div>
		<div class="row">
			<div class="col-md-4">
				<base-filter-bar placeholder="Search Generic Entities"></base-filter-bar>
			</div>
			<div class="col-md-8">
				<base-select-visible :per-page="perPage" :amounts-shown="amountsShown"></base-select-visible>
			</div>
		</div>
		<div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
		    <vuetable ref="vuetable"
				:api-url="grid"
				:fields="fields"
				:css="css.table"
				:per-page="perPage"
				pagination-path=""
				noDataTemplate="No Generic Entities Found"
				:append-params="moreParams"
				@vuetable:pagination-data="onPaginationData"
		    >
		    	<template slot="activity" slot-scope="props">
		    			<div class="activity-entry"  v-if="props.rowData.created_by" :class="{'no-update': !props.rowData.created_by}"><strong>Created By:</strong> {{props.rowData.created_by.name}}</div>
						<div  class="activity-entry"  v-else><strong>Created By:</strong> N/A</div>
		    			<div  class="activity-entry" v-if="props.rowData.updated_by"><strong>Updated By:</strong> {{props.rowData.updated_by.name}}</div>
						<div  class="activity-entry" v-else><strong>Updated By:</strong> N/A</div>
		    	</template>
	    	    <template slot="actions" slot-scope="props">
		    	        <a class="btn btn-outline-primary" :href="'/generic-entities/' + props.rowData.id + '/edit'">View</a>
		    	</template>
		    </vuetable>
		    <div class="row">
		    	<div class="col-md-6">
		    		<base-pagination-info
		    			:css="css.table"
		    			ref="paginationInfo"
		    		>
		    		</base-pagination-info>
		    	</div>
		    	<div class="col-md-6">
		    		<base-pagination  ref="pagination"
		    		  @vuetable-pagination:change-page="onChangePage"
		    		></base-pagination>
		    	</div>
		    </div>
		</div>
	</div>
</template>

<style lang="scss">
	.activity-column{
		width: 194px;
	}
</style>

<style scoped lang="scss">
	.activity-entry{
		font-size: 11px;
		&.no-update{
			font-size: 13px;
		}
	}
	.mr7{
		margin-right: 7px;
	}
	.mr2{
		margin-right: 2px;
	}
	.table-button-container{
		text-align: center;
	}
	.channel-container{
		position: relative;
		.channel-expander{
			background: #25628F;
			z-index:2;
			width: 16px;
			height: 16px;
			border-radius: 50%;
			color:#fff;
			position: absolute;
			text-align: center;
			right: 5px;
			bottom: 3px;
			font-size: 10px;
			padding-top: 1px;
			&:before{
				content: "\F110";
				font: normal normal normal 14px/1 "LineAwesome";
				color: #fff;
     			font-size: 10px;
			}
			&.open{
				&.scrolled{
					right: 7px;
				}
				&:before{
					content:"\f113";
				}
			}
		}
	}
	.channel-item-container{
		transition: all 0.3s;
		z-index:1;
		max-height: 59px;
		min-height: 59px;
		overflow:hidden;
		&.open{
			transition: all 0.5s;
			max-height: 199px;
		}
		&.scrolled{
			overflow-y:overlay;
		}
		&::-webkit-scrollbar {
		    width: 4px;
		}
		&::-webkit-scrollbar-track {
		    background: rgba(0,0,0,0.1);
		    position: absolute;
		    top: 0px;
		    bottom: 0px;
		    right: 0px;
		}
		&::-webkit-scrollbar-thumb {
		    background: #25628F;
		    border-radius:2px;
		}
		&::-webkit-scrollbar-thumb:hover {
		    background: #25628F;
		}
	}
	.channel-item{
		border-bottom:1px solid #dee0e1;
		padding: 2px 7px;
		font-size: 10px;
		position: relative;
		&:nth-child(n+3):last-child{
			border-color:transparent;
		}
	}
	.no-channel{
		text-align: center;
		padding: 20px 0;
	}
</style>

<script type="text/javascript">

	var base_url = window.location.protocol + "//" + window.location.host

	import Vue from 'vue';
	import VueEvents from 'vue-events'
	import * as Vuetable from 'vuetable-2';
	import moment from 'moment';
	import BaseFilterBar from './base-filter-bar.vue';
	import BasePagination from './base-pagination.vue';
	import BasePaginationInfo from './base-pagination-info.vue';
	import BaseSelectVisible from './base-select-visible.vue';

	Vue.use(VueEvents)

	export default {
	    name: 'generic-entities',
	    props: [],
	    components:{
	     	'base-filter-bar': BaseFilterBar,
	     	'base-pagination': BasePagination,
	     	'base-pagination-info': BasePaginationInfo,
	     	'base-select-visible': BaseSelectVisible,
	    },
	    data() {
	    	return {
	    		perPage: 10,
	    		moreParams: {},
				fields: [
					{
						name: 'priority',
						sortField: 'priority',
						dataClass: 'actions-single-column text-center',
					},
					{
						name: 'name',
						sortField: 'name',
					},
					// {
					// 	name: 'description',
					// 	sortField: 'description'
					// },
					{
						name: '__slot:activity',
						title: 'Activity',
						titleClass: 'activity-column',
					},
					{
						name: 'publishable',
						dataClass: 'text-center',
						sortField: 'publishable',
						callback: 'publishable',
						titleClass: 'actions-single-column',
					},
					{
						name: 'is_product_attribute',
						title: 'Visible',
						dataClass: 'text-center',
						sortField: 'is_product_attribute',
						callback: 'productAttribute',
						titleClass: 'actions-single-column',
					},
					{
						name: 'is_tree',
						title: 'Nested List',
						dataClass: 'text-center',
						sortField: 'is_tree',
						callback: 'isTree',
						titleClass: 'actions-single-column',
					},
					{
						name: 'display_on_navigation',
						title: 'Navigation',
						dataClass: 'text-center',
						sortField: 'display_on_navigation',
						callback: 'displayNav',
						titleClass: 'actions-single-column',
					},
					{
						name: 'is_multiselect',
						title: 'Multiselect',
						dataClass: 'text-center',
						sortField: 'is_multiselect',
						callback: 'displayNav',
						titleClass: 'actions-single-column',
					},
					{
						name: 'has_price_profile',
						title: 'Price Profile',
						dataClass: 'text-center',
						sortField: 'has_price_profile',
						callback: 'displayNav',
						titleClass: 'actions-single-column',
						visible: this.hasFeature('price_profiles')
					},
					{
						name: '__slot:actions',
						titleClass: 'actions-single-column',
					},
				],
				amountsShown: [
					{ text: '10', value: 10 },
					{ text: '25', value: 25 },
					{ text: '50', value: 50 },
					{ text: '100', value: 100 }
				],
				grid: base_url + "/generic-entities/grid",
				css: {
					table: {
						tableClass: 'table table-striped table-bordered table-middle',
						ascendingIcon: 'sort-icon-asc',
						descendingIcon: 'sort-icon-desc',
						infoClass: '',
					},
				},
			}
	    },
	    mounted() {
	    	this.$events.$on('per-page', eventData => this.doVisibleSet(eventData))
           	this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
           	this.$events.$on('filter-reset', e => this.onFilterReset())
	    },
	    watch: {
			'perPage' (val, oldVal) {
		      this.$nextTick(function() {
		        	this.$refs.vuetable.refresh()
		      })
		    },
	    },
	    methods: {
			hasFeature (value) {
				return this.$parent.enabledFeatures.indexOf(value) !== -1;
			},
	    	publishable (value) {
	    	 	return value == 1
	    	   		? '<div class="badge w-100 badge-success">Published</div>'
	    	   		: '<div class="badge w-100 badge-warning">Suppressed</div>'
	    	},
	    	productAttribute (value) {
	    	 	return value == 1
	    	   		? '<div class="badge w-100 badge-success">Yes</div>'
	    	   		: '<div class="badge w-100 badge-warning">No</div>'
	    	},
	    	isTree (value) {
	    	 	return value == 1
	    	   		? '<div class="badge w-100 badge-success">Yes</div>'
	    	   		: '<div class="badge w-100 badge-warning">No</div>'
	    	},
	    	displayNav (value) {
	    	 	return value == 1
	    	   		? '<div class="badge w-100 badge-success">Yes</div>'
	    	   		: '<div class="badge w-100 badge-warning">No</div>'
	    	},
	    	overrideBadge (value) {
			 	return value
			   		? '<div class="badge badge-success">Yes</div>'
			   		: '<div class="badge badge-danger">No</div>'
			},
			formatDate (value) {
				if (value === null) {
					return 'Never';
				}
			 	return moment(value).format("MMM Do YY");
			},
	        onPaginationData (paginationData) {
	          	this.$refs.pagination.setPaginationData(paginationData)
	          	this.$refs.paginationInfo.setPaginationData(paginationData)
	        },
	        onChangePage (page) {
	          	this.$refs.vuetable.changePage(page)
	        },
	        expandChannelsList () {
	        	$(event.target).next().toggleClass('open')
	        	$(event.target).toggleClass('open')
	        },
	        editRow(rowData){
	        	console.log(rowData);
	        },
	        doVisibleSet (perPageValue) {
                this.perPage = perPageValue;
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
	        onFilterSet (filterText) {
                this.moreParams = {
                    'filter': filterText
                }
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
            onFilterReset () {
                this.moreParams = {}
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            }
		}
	};
</script>
